import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Text } from '@chakra-ui/react';
import { useJaenPageIndex } from '../../contexts/page';
import { withRedux } from '../../redux/index';
import { HighlightTooltip } from '../components/HighlightTooltip/HighlightTooltip';
export const IndexField = withRedux(({ name, renderPage, ...rest }) => {
    const { childPages, withJaenPage } = useJaenPageIndex(rest);
    return (_jsx(HighlightTooltip, { id: name, actions: [
            _jsx(Button, { variant: 'jaen-highlight-tooltip-text', children: _jsx(Text, { as: "span", lineClamp: 1, children: "Index" }) }, "jaen-highlight-tooltip-text-index")
        ], children: childPages.map(page => withJaenPage(page.id, renderPage(page))) }));
});
export default IndexField;
